import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";

// ------------------ COMPONENTES DE BASE--------------------------
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import Card from "../../../../../../Base/Components/Card/Card";
import { useForm } from "../../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import Loader from "../../../../../../Base/Components/Loader/Loader";

// ------------------- CONSULTAS A LA API---------------------------
import { ObtenerDetalleRequisa, ObtenerEncabezadoRequisa, } from "../../../../../../API/Suministros/IngresosMateriales/IngresosMaterialesRequest";
import { getLiberarRequisas } from "../../../../../../Base/API/IT/Accesos/AccesosRequests";
import { getAreasAct } from "../../../../../../Base/API/Global/Areas/AreasRequests";
import { obtenerPrioridadesAct } from "../../../../../../Base/API/Global/Prioridades/PrioridadesRequests";
import { getListadoImagenes, mostrarImagenesProductos } from "../../../../../../Base/API/IT/Imagenes/ImagenesRequest";
import { EliminarSalidasMateriales, ObtenerDetalleSalidas, editarSalidaM, guardarSalidaM } from "../../../../../../API/Suministros/SalidasMateriales/SalidasMaterialesRequest"; 


// ------------------ COMPONENTES DE NECESARIOS--------------------------
import EncabezadoSalidasMateriales from "../EncabezadoSalidasMateriales/EncabezadoSalidasMateriales";
import ProductosOverlay from "./ProductosOverlay/ProductosOverlay";
import AgregarSalidas from "./AgregarSalidas";
import IngresosBodegaCrud from "../../IngresosBodega/IngresosCRUD/IngresosBodegaCrud";

const SalidasMaterialesCrud = ({
  idIngreso,
  requisa,
  actualizarScreen,
  // setIngresoToShow,
  habilitar,
  setHabilitar
}) => {

  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [detalles, setDetalles] = useState([]);
  const [encabezado, setEncabezado] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [NoIngreso, setNoIngreso] = useState([]);
  const [agentes, setAgentes] = useState([]);
  const [areas, setareas] = useState([]); 
  const [prioridades, setPrioridades] = useState([]);
  const [imagenes, setImagenes] = useState([]);
  const [mostrarCarousel, setMostrarCarousel] = useState(true);
  const [showDialogS, setShowDialogS] = useState(false);
  const [showDialog, setShowDialog] = useState(false); //MODAL INGRESOS
  const [detallesRequisa, setDetallesRequisa] = useState(false);
  const [ingresoToShow, setIngresoToShow] = useState([]);

  const [hiddenCostosSalidas, setHiddenCostosSalidad] = useState(
    userAuth.AccessWeb.split(",")
      .map((e) => parseInt(e))
      .includes(29)
  );

  //PARA ENCABEZADO  VALUES
  const initialValues = {
    FechaEnc: new Date(),
    IdSalidaDetalle: -1,
    Requisa: requisa?.Requisa,
    Comentarios:"",
    IdPersonalRecibe:null
  };

  const { values, setValues, handleInputChange, handleChange, resetForm } = useForm(initialValues);

  // OBTENER INFORMACION PARA LOS DROPDAWN
  const getInfo = async () => {
    setLoading(true);

    const agentesSolicita = await getLiberarRequisas();
    setAgentes(agentesSolicita);

    const areasActivas = await getAreasAct();
    setareas(areasActivas);

    const prioridadesActivas = await obtenerPrioridadesAct();
    setPrioridades(prioridadesActivas);
    setLoading(false);
  };

  // OBTENER PARA EDITAR UNA SALIDA
  const obtenerSalidas = async (salidas) => {
    setLoading(true);

    const ObtDetallesRequisa = await ObtenerDetalleRequisa(requisa?.Requisa)
    setDetallesRequisa(ObtDetallesRequisa)

    let req = salidas ? salidas : values;
    const det = await ObtenerDetalleSalidas(req.Requisa);
    setDetalles(det);

    const t = await ObtenerEncabezadoRequisa(req.Requisa);
    setEncabezado(t);

    const agentesSolicita = await getLiberarRequisas();
    setAgentes(agentesSolicita);

    if (t.length > 0) {
      setMostrarCarousel(true);
      const [detailIngresos] = t;
      const n = {
        ...detailIngresos,
        FechaEnc: new Date(detailIngresos.FechaEnc),
        UserNameSolicita: agentesSolicita.find(
          (ac) => ac.IdUser === detailIngresos.IdSolicita
        ),
      };

      setValues(n);
      setIngresoToShow(detailIngresos.Requisa)
      setHabilitar(false);
    } else {
      setMostrarCarousel(false);
      const d = {
        ...initialValues,
        Requisa: values.Requisa,
      };
      setValues(d);
      setDetalles([]);
      toastShow( toast, "error", "Error al obtener", "No se encontro la salida.");
      setHabilitar(true);
    }
    setLoading(false);
  };

  // AGREGAR NUEVA FILA
  const agregarNuevaFila = () => {
    // setShowDialogS(true)
    let newRowData = [...detalles];
    let index = -1 * parseInt((+new Date().getTime() + "").substring(9, 14));
    const newData = {
      IdSalidaDetalle: index,
      FechaSalida: new Date(),
      IdEstado: 38,
      StatusName: "Despachado",
      IdIngresoDetalle: null,
      Ingreso: null,
      QtySalida:null,
      IdProducto: null,
      CodigoProducto: "",
      NombreProducto: "",
      IdUnit: "",
      UnitName: "",
      IdArea:"",
      Area: values.Area.Area,
      ComentarioRequisa: values.Comentarios,
      UserNameDespacho: userAuth.UserName,
      PrecioL: 0,
      PrecioD: 0,
      MontoL: 0,
      MontoD: 0,
      IdRequisaDet: null,
    };

    if (newRowData.length > 0) {
      if (
        newRowData[newRowData.length - 1].IdProducto ||
        newRowData[newRowData.length - 1].IdIngresoDetalle
      ) {
        newRowData.push(newData);
      } else {
        newRowData[newRowData.length - 1] = newData;
      }
    } else {
      newRowData.push(newData);
    }
    setDetalles(newRowData);
  };

  const agregarSalidas = async () => {
    let guardar = true;
    setLoading(true);
    if (detalles.length === 0) {
      toastShow( toast, "error", "Error al guardar", "Debe seleccionar al menos un Producto.");
      guardar = false;
    } else{
      detalles.forEach((d) => {
        if (d.CodigoProducto === "") {
          toastShow( toast, "error", "Error al guardar", "Todos los items deben contener un Producto.");
          guardar = false;
        }
      });
    }
    detalles.forEach((d) => {
      if (d.QtySalida === null) {
        toastShow( toast, "error", "Error al guardar", "Ingrese la cantidad a Despachar.");
        guardar = false;
      }
    });
    
    detalles.forEach((d) => {
      if (d.QtySalida === null || d.QtySalida <= 0) {
        toastShow( toast, "error", "Error", "Ingrese una cantidad válida a Despachar.");
        guardar = false;
      }
    });

    if (guardar) {
      const detallesSalida = detalles.map((detalle) => ({
        ...detalle[0],
        IdSalidaDetalle: detalle?.IdSalidaDetalle,
        IdRequisaDet: detalle?.IdRequisaDetalle,
        IdProduct: detalle.IdProducto,
        CantidadADespachar: detalle.QtySalida,
        IdUsuarioDespacho: userAuth.IdUser,
      }));

      if(detallesSalida[0].IdSalidaDetalle > 0){
        const resultado = await editarSalidaM(detallesSalida);
        if (resultado[0].ESTADO !== 1) {
          toastShow(toast, "error", "Error", resultado[0].MENSAJE);
          setLoading(false);
        } else {
          getInfo();
          actualizarScreen();
          toastShow(toast, "success", "Datos Editados", resultado[0].MENSAJE);
          obtenerSalidas()
        }
      }else{
        const resultado = await guardarSalidaM(detallesSalida);
        if (resultado[0].ESTADO !== 1) {
          toastShow(toast, "error", "Error", resultado[0].MENSAJE);
          setLoading(false);
        } else {
          getInfo();
          actualizarScreen();
          toastShow(toast, "success", "Datos Agregados", resultado[0].MENSAJE);
          obtenerSalidas()
        }
      }
    }
    setLoading(false)
  };

  // ELIMINAR ITEM
  const eliminarSalida = async () => {
    if(selected.length === 0){
        toastShow( toast, "warn", "Advertencia", "Seleccione una salida de Material a Eliminar.");
        return;
    }else{
      selected.forEach(async (select) => {
        if (selected.length > 0) {
          const a = {
            IdRequisaDet: select?.IdRequisaDetalle,
            IdProduct: select?.IdProducto,
            CantidadADespachar: select?.QtySalida,
            IdUsuarioDespacho: select?.IdUsuarioDespacho,
            CantidadADespachar: select?.QtySalida
          }
          const response = await EliminarSalidasMateriales(a)
          if (response[0].ESTADO !== -1) {
            toastShow( toast, "success", "Eliminado", response[0].MENSAJE);
            getInfo()
          } else {
            toastShow( toast, "error", "Error", response[0].MENSAJE);
          }
        } 
      })
    }
  };

  // CAMBIAR CANTIDAD DE SALIDA
  const changeQtySalida = ({ data, oldValue, column }) => {
    const index = detalles.findIndex(
      (detail) => detail.IdSalidaDetalle === data.IdSalidaDetalle
    );
    let newDetail = [...detalles];

    if (column.colId === "QtySalida") {
      if (data.QtySalida > (data.BalanceSalida + oldValue) ) {
        toastShow( toast, "error", "Error", "La cantidad de salida es mayor que el balance.");
        data.QtySalida = 0;
      } else {
        newDetail[index].QtySalida = data?.QtySalida;
      }
    }

    setDetalles(newDetail);
  };

  const changeProducto = ({ data }) => {
    return (
      <ProductosOverlay
        Requisa={values?.Requisa}
        rowData={data}
        onChange={({ api, data }, rowData) => {
          const index = detalles.findIndex(
            (detail) =>
              detail.IdSalidaDetalle ===
              rowData.IdSalidaDetalle
          );
          let newDetail = [...detalles];
          newDetail[index].IdProducto = data.IdProducto;
          newDetail[index].NombreProducto = data.NombreProducto;
          newDetail[index].CodigoProducto = data.CodigoProducto;
          newDetail[index].Qty = data.Qty;
          newDetail[index].Area = data.Area;
          newDetail[index].Comentarios = data.Comentarios;
          newDetail[index].Inventario = data.Quantity;
          newDetail[index].BalanceSalida = data.BalanceSalida;
          newDetail[index].QtySalida = 0;
          newDetail[index].IdRequisaDetalle = data.IdRequisaDet;

          // newDetail[index].QtySalida = null;
          setDetalles(newDetail);
          api.stopEditing();
        }}
      />
    );
  };

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && ingresoToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialog(null);
          setIngresoToShow(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialog(null);
      setIngresoToShow(null);
      setHabilitar(true);
    }
  };

  const columns = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdSalidaDetalle",
      frozen: true,
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      header: "Fecha Salida",
      headerEn: "Departure Date",
      field: "FechaSalida",
      Format: "DateTime",
      frozen: true,
      className: "medium",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      frozen: true,
      className: "small",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData?.IdEstado,
        Estado: rowData?.StatusName,
      }),
    },
    {
      header: "Código Producto",
      headerEn: "Purchase Order",
      className: "Xsmall",
      field: "CodigoProducto",
      editable: habilitar,
      cellEditor: changeProducto,
    },
    {
      header: "Producto",
      headerEn: "Product",
      field: "NombreProducto",
      className: "large",
    },
    {
      header: "Descripción Producto",
      headerEn: "Product Description",
      field: "DescripcionProducto",
      className: "large",
    },
    {
      header: "Comentario de Salida",
      headerEn: "Comment",
      field: "Comentario",
      className: "large",
    },
    {
      header: "Tipo Producto",
      headerEn: "Product Type",
      field: "NombreCategoria",
      className: "Xsmall",
    },
    {
      header: "Categoría",
      headerEn: "Category",
      field: "NombreSubcategoria",
      className: "Xsmall",
    },
    {
      header: "SubCategoría",
      headerEn: "SubCategory",
      field: "NombreTipoProducto",
      className: "small",
    },
    {
      // PurchaseRequest
      field: "NumeroIngreso",
      headerEn: "Entry Number",
      header: "No.Ingreso",
      className: "Xsmall",
      body: (rowData) => rowData.NumeroIngreso,
      // Format: "Modal",
      align: "center",
      //   Sumary: "count",
        onCellDoubleClicked: ({ data }) => {
          setIngresoToShow(data?.NumeroIngreso)
          setShowDialog(true)
          // Ingreso(data.Requisa);
        },
    },
    {
      header: "Unidad",
      headerEn: "Product",
      field: "UnitName",
      className: "Xsmall",
    },
    {
      // Comment
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "medium",
      body: (rowData) => rowData.UnitName,
    },
    // {
    //   // Comment
    //   field: "ComentarioRequisa",
    //   header: "Comentario Requisa",
    //   headerEn: "Comment Requisition",
    //   className: "colum-width-Xlarge",
    //   body: (rowData) => rowData.UnitName,
    // },
    {
      // Comment
      field: "UserNameDespacho",
      header: "Usuario Despacho",
      headerEn: "Usuario Despacho",
      className: "small",
      body: (rowData) => rowData.UnitName,
    },
    {
      field: "ComprasPrecioL",
      header: "Precio L",
      headerEn: "Price L",
      Sumary: "sum",
      className: "Xsmall",
      hidden: hiddenCostosSalidas,
      Format: "Currency",
    },
    {
      field: "ComprasPrecioD",
      header: "Precio D",
      headerEn: "Price D",
      Sumary: "sum",
      className: "Xsmall",
      Format: "Currency",
      hidden: hiddenCostosSalidas
    },
    {
      field: "MontoInvL",
      header: "Monto L",
      headerEn: "Monto L",
      className: "Xsmall",
      hidden: hiddenCostosSalidas,
      Sumary: "sum",
      frozen: "frozen",
      Format: "Currency",
      alignFrozen: "right",
    },
    {
      field: "MontoInvD",
      header: "Monto D",
      headerEn: "Monto D",
      className: "small",
      hidden: hiddenCostosSalidas,
      Sumary: "sum",
      Format: "Currency",
      frozen: "frozen",
      alignFrozen: "right",
    },
    {
      header: "Inventario",
      headerEn: "Amount",
      field: "Inventario",
      className: "Xsmall",
      Sumary: "sum",
      Format: "Currency",
    },
    {
      header: "Solicitado",
      headerEn: "Requested",
      field: "Qty",
      className: "Xsmall",    
      Sumary: "sum",
      Format: "Currency",     
      frozen: "frozen",
      alignFrozen: "right", 
    },
    {
      header: "Balance",
      field: "BalanceSalida",
      className: "Xsmall",    
      Sumary: "sum",
      Format: "Currency",
      frozen: "frozen",
      alignFrozen: "right",
    },
    {
      header: "Despachado",
      field: "QtySalida",
      className: "Xsmall",    
      editable: habilitar,
      onChange: (data) => changeQtySalida(data),
      Sumary: "sum",
      Format: "Currency",
      frozen: "frozen",
      alignFrozen: "right",
    },
  ];

  const table = {
    Columns: columns,
    Data: detalles,
    selected: selected,
    setSelected: setSelected,
    onCellFocused: (e, a) => {
      if (!e.rowPinned) {
        getImagenes(a[e.rowIndex].data);
      }
    },
  };

  const getImagenes = async (productos) => {
    if (imagenes?.CodigoProducto !== productos?.CodigoProducto) {

      const i = await getListadoImagenes(productos?.CodigoProducto);
      if (i?.length > 0) {
        let n = await Promise.all(i.map(async (e) => {
          try {
            const a = await mostrarImagenesProductos(productos?.CodigoProducto, e);
            return a;
          } catch (e) {
            return e;
          }
        }));
        setImagenes({ CodigoProducto: productos?.CodigoProducto, img: n });
      } else {
        setImagenes([]);
      }
    }
  };



  useEffect(() => {
    getInfo();
    setDetalles([]);
      obtenerSalidas();
  }, [idIngreso]);

  return (
    <div>
      <Loader loading={loading} />
      <Toast ref={toast} />
      <EncabezadoSalidasMateriales
        values={values}
        handleInputChange={handleInputChange}
        handleChange={handleChange}
        setHabilitar={setHabilitar}
        toast={toast}
        resetForm={resetForm}
        detalles={detalles}
        setDetalles={setDetalles}
        getIngreso={obtenerSalidas}
        habilitar={habilitar}
        setValues={setValues}
        idIngreso={idIngreso}
        agentes={agentes}
        areas={areas}
        prioridades={prioridades}
        agregarNuevaFila={agregarNuevaFila}
        eliminarItemDetalle={eliminarSalida}
        guardarSalidaMaterial={agregarSalidas}
        imagenes={imagenes}
        setMostrarCarousel={setMostrarCarousel}
        mostrarCarousel={mostrarCarousel}
        setIngresoToShow={setIngresoToShow}
      />
      <Card
        contenido={
          <div style={{ height: "70vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      {showDialogS && (
        <AgregarSalidas
          idIngreso={requisa?.Requisa}
          requisaDet={selected[0] || selected}
          showDialog={showDialogS}
          setShowDialog={setShowDialogS}
          getInfo={getInfo}
          actualizarScreen={actualizarScreen}
        />
      )}



      <Dialog
        visible={showDialog}
        onHide={() => {
          cerrarConfirmacion();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <IngresosBodegaCrud
          idIngreso={ingresoToShow}
          setIngresoToShow={setIngresoToShow}
          showDialog={showDialog}
          // actualizarIngresosScreen={actualizarIngresosScreen}
          // actualizarIngresosScreenListado={actualizarIngresosScreenListado}
          // setOrderToShow={setOrderToShow}
          // setOrdenDialog={setOrdenDialog}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
        />
      </Dialog>



    </div>
  );
};

export default SalidasMaterialesCrud;